import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import {
  TrendingUp,
  BarChart3,
  LineChart,
  Activity,
  Shield,
  BookOpen,
  Target,
  CheckCircle2,
  Database,
  Users,
  Star,
  Phone,
  Send,
  Mail,
  Youtube,
  Twitter,
  Instagram,
  Facebook,
  ChevronDown,
  Menu,
  X,
  ArrowRight,
  DollarSign,
  MessageCircle,
  Award,
  BadgeCheck,
  PhoneCall,
  Smartphone,
  Bell,
  Rocket
} from 'lucide-react';
import {
  heroData,
  aboutData,
  servicesData,
  technicalResearchData,
  whyChooseUsData,
  testimonialsData,
  contactData,
  disclaimerData,
  youtubeData,
  upcomingAppData
} from '../mock';

const iconMap = {
  TrendingUp,
  BarChart3,
  LineChart,
  Activity,
  Shield,
  BookOpen,
  Target,
  CheckCircle2,
  Database,
  Users,
  DollarSign
};

const Home = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const handleOpenAccount = () => {
    window.open(heroData.affiliateLink, '_blank');
  };

  const handleForexFundedAccount = () => {
    window.open(heroData.forexFundedLink, '_blank');
  };

  const handlePremiumSubscription = () => {
    window.open(heroData.premiumSubscriptionLink, '_blank');
  };

  const handleZuperior = () => {
    window.open(heroData.zuperiorLink, '_blank');
  };

  const handleVantage = () => {
    window.open(heroData.vantageLink, '_blank');
  };

  const handleElefin = () => {
    window.open(heroData.elefinLink, '_blank');
  };

  const handleIndiabullsDemat = () => {
    window.open(heroData.indiabullsDematLink, '_blank');
  };

  const handleYouTube = () => {
    window.open(youtubeData.channelUrl, '_blank');
  };

  const handleWhatsApp = () => {
    window.open(contactData.whatsappLink, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FF6B1A] via-[#FF8533] to-[#FF6B1A]">
      {/* Top WhatsApp Bar */}
      <div className="fixed top-0 w-full bg-gradient-to-r from-green-600 to-green-500 z-[60] shadow-md">
        <div className="container mx-auto px-4 py-2">
          <button
            onClick={handleWhatsApp}
            data-testid="top-whatsapp-bar-btn"
            className="w-full flex items-center justify-center space-x-2 text-white font-semibold text-sm md:text-base hover:opacity-90 transition-opacity"
          >
            <MessageCircle className="h-4 w-4 md:h-5 md:w-5" />
            <span>Chat on WhatsApp Now</span>
            <span className="hidden sm:inline">— Get Instant Support</span>
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>

      {/* Header */}
      <header className="fixed top-9 md:top-10 w-full bg-[#050e24]/90 backdrop-blur-md border-b border-[#1d3263] z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <LineChart className="h-8 w-8 text-amber-400" />
              <span className="text-xl font-bold text-white">DD Financial Services By Deepak Chart Analysis</span>
            </div>
            
            {/* Desktop Menu */}
            <nav className="hidden md:flex items-center space-x-5">
              <button onClick={() => scrollToSection('about')} className="text-slate-300 hover:text-amber-400 transition-colors text-sm">About</button>
              <button onClick={() => scrollToSection('services')} className="text-slate-300 hover:text-amber-400 transition-colors text-sm">Services</button>
              <button onClick={() => scrollToSection('research')} className="text-slate-300 hover:text-amber-400 transition-colors text-sm">Research</button>
              <button onClick={() => scrollToSection('testimonials')} className="text-slate-300 hover:text-amber-400 transition-colors text-sm">Testimonials</button>
              <button onClick={() => scrollToSection('elefin')} data-testid="nav-elefin-tab" className="text-amber-400 font-semibold hover:text-yellow-300 transition-colors text-sm">ELEFIN Forex</button>
              <button onClick={() => scrollToSection('vantage')} data-testid="nav-vantage-tab" className="text-amber-400 font-semibold hover:text-yellow-300 transition-colors text-sm">Vantage Markets</button>
              <Button onClick={handlePremiumSubscription} className="bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-700 hover:to-orange-700 text-white">
                Premium
              </Button>
              <Button onClick={handleOpenAccount} className="bg-gradient-to-r from-amber-400 to-yellow-500 text-[#050e24] hover:from-amber-500 hover:to-yellow-600 font-semibold">
                Open Account
              </Button>
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <nav className="md:hidden mt-4 pb-4 flex flex-col space-y-3">
              <button onClick={() => scrollToSection('about')} className="text-slate-300 hover:text-amber-400 transition-colors text-left">About</button>
              <button onClick={() => scrollToSection('services')} className="text-slate-300 hover:text-amber-400 transition-colors text-left">Services</button>
              <button onClick={() => scrollToSection('research')} className="text-slate-300 hover:text-amber-400 transition-colors text-left">Research</button>
              <button onClick={() => scrollToSection('testimonials')} className="text-slate-300 hover:text-amber-400 transition-colors text-left">Testimonials</button>
              <button onClick={() => scrollToSection('elefin')} data-testid="mobile-nav-elefin-tab" className="text-amber-400 font-semibold hover:text-yellow-300 transition-colors text-left">ELEFIN Forex Account</button>
              <button onClick={() => scrollToSection('vantage')} data-testid="mobile-nav-vantage-tab" className="text-amber-400 font-semibold hover:text-yellow-300 transition-colors text-left">Vantage Markets Account</button>
              <Button onClick={handlePremiumSubscription} className="bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-700 hover:to-orange-700 text-white w-full">
                Premium Subscription
              </Button>
              <Button onClick={handleOpenAccount} className="bg-gradient-to-r from-amber-400 to-yellow-500 text-[#050e24] hover:from-amber-500 hover:to-yellow-600 w-full font-semibold">
                Open Account
              </Button>
            </nav>
          )}
        </div>
      </header>

      {/* Upcoming App Launch Section */}
      <section id="mobile-app" data-testid="mobile-app-section" className="pt-40 md:pt-44 pb-16 px-4 bg-gradient-to-br from-[#050e24] via-[#0a1b3d] to-[#050e24] border-b border-amber-400/20">
        <div className="container mx-auto">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-10">
              <div className="app-flash-banner inline-flex items-center gap-2 bg-gradient-to-r from-amber-400 to-yellow-500 text-[#050e24] rounded-full px-5 py-2 mb-4 font-extrabold text-sm md:text-base shadow-lg" data-testid="app-launch-flash-banner">
                <Smartphone className="h-5 w-5" />
                <span>NEW: Mobile Application Launching Soon on Play Store!</span>
              </div>
              <br />
              <div className="inline-flex items-center gap-2 bg-amber-400/15 backdrop-blur-md border border-amber-400/40 rounded-full px-4 py-1.5 mb-4 animate-pulse">
                <Rocket className="h-4 w-4 text-amber-400" />
                <span className="text-amber-400 text-sm font-bold tracking-widest">{upcomingAppData.status}</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
                <span className="text-amber-400">{upcomingAppData.name}</span>
              </h2>
              <p className="text-slate-300 text-lg max-w-2xl mx-auto mb-2">
                {upcomingAppData.tagline}
              </p>
              <p className="text-slate-400 text-base max-w-2xl mx-auto">
                {upcomingAppData.description}
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              {/* Left: Phone mockup */}
              <div className="flex justify-center">
                <div className="relative">
                  <div className="absolute -inset-4 bg-gradient-to-r from-amber-400 via-yellow-500 to-amber-400 rounded-[2.5rem] blur-2xl opacity-30 animate-pulse"></div>
                  <div className="relative bg-gradient-to-br from-[#0a1b3d] to-[#050e24] border-4 border-amber-400/40 rounded-[2.5rem] p-6 shadow-2xl w-72 h-[480px] flex flex-col items-center justify-center" data-testid="app-mockup">
                    <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-amber-400 to-yellow-500 flex items-center justify-center mb-5 shadow-lg">
                      <Smartphone className="h-10 w-10 text-[#050e24]" />
                    </div>
                    <p className="text-amber-400 text-xl font-bold mb-2 text-center leading-tight">Deepak Chart<br/>Analysis</p>
                    <p className="text-white text-xs text-center mb-6 px-4">DD Financial Services By Deepak Chart Analysis Mobile App</p>
                    <div className="w-full space-y-2 px-2">
                      <div className="bg-amber-400/10 border border-amber-400/30 rounded-lg px-3 py-2 flex items-center gap-2">
                        <TrendingUp className="h-4 w-4 text-amber-400 flex-shrink-0" />
                        <span className="text-slate-200 text-xs">Live Charts</span>
                      </div>
                      <div className="bg-amber-400/10 border border-amber-400/30 rounded-lg px-3 py-2 flex items-center gap-2">
                        <Bell className="h-4 w-4 text-amber-400 flex-shrink-0" />
                        <span className="text-slate-200 text-xs">Instant Alerts</span>
                      </div>
                      <div className="bg-amber-400/10 border border-amber-400/30 rounded-lg px-3 py-2 flex items-center gap-2">
                        <BookOpen className="h-4 w-4 text-amber-400 flex-shrink-0" />
                        <span className="text-slate-200 text-xs">Educational Hub</span>
                      </div>
                    </div>
                    <div className="mt-6 bg-green-600/20 border border-green-500/40 rounded-full px-4 py-1.5">
                      <p className="text-green-400 text-xs font-bold">COMING SOON</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right: Features */}
              <div className="space-y-4">
                {upcomingAppData.features.map((feature, idx) => (
                  <div key={idx} className="bg-[#0a1b3d]/60 border border-[#1d3263] rounded-xl p-5 hover:border-amber-400/50 transition-colors" data-testid={`app-feature-${idx}`}>
                    <div className="flex items-start gap-4">
                      <div className="w-11 h-11 rounded-lg bg-gradient-to-br from-amber-400 to-yellow-500 flex items-center justify-center flex-shrink-0">
                        <CheckCircle2 className="h-5 w-5 text-[#050e24]" />
                      </div>
                      <div>
                        <p className="text-white font-semibold text-base mb-1">{feature.title}</p>
                        <p className="text-slate-400 text-sm">{feature.description}</p>
                      </div>
                    </div>
                  </div>
                ))}

                <div className="bg-gradient-to-r from-amber-400/20 to-yellow-500/10 border border-amber-400/40 rounded-xl p-5 mt-6">
                  <div className="flex items-center gap-3">
                    <Rocket className="h-6 w-6 text-amber-400 flex-shrink-0" />
                    <div>
                      <p className="text-amber-400 font-bold text-sm uppercase tracking-wider">Launching Soon</p>
                      <p className="text-white text-sm">Google Play Store par जल्दी available होगा — stay tuned!</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hero Section */}
      <section className="pt-20 pb-20 px-4">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
            {/* Left: Text */}
            <div className="text-center lg:text-left order-2 lg:order-1">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0a1b3d] mb-6 leading-tight drop-shadow-sm">
                {heroData.heading}
              </h1>
              <p className="text-lg md:text-xl text-[#0a1b3d]/90 font-medium mb-8">
                {heroData.subheading}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start flex-wrap">
                <Button
                  onClick={() => scrollToSection('research')}
                  size="lg"
                  data-testid="hero-view-research-btn"
                  className="bg-white text-[#0a1b3d] hover:bg-slate-100 text-base px-6 py-5"
                >
                  {heroData.ctaPrimary}
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
                <Button
                  onClick={handleWhatsApp}
                  size="lg"
                  data-testid="hero-whatsapp-btn"
                  className="bg-green-600 hover:bg-green-700 text-white text-base px-6 py-5"
                >
                  <MessageCircle className="mr-2 h-5 w-5" />
                  WhatsApp Us
                </Button>
              </div>
            </div>

            {/* Right: Profile Photo */}
            <div className="order-1 lg:order-2 flex justify-center">
              <div className="relative" data-testid="hero-profile-photo-wrap">
                <div className="absolute -inset-1 bg-gradient-to-r from-amber-400 via-yellow-500 to-amber-400 rounded-2xl blur-lg opacity-60 animate-pulse"></div>
                <div className="relative rounded-2xl overflow-hidden border-2 border-amber-400/50 shadow-2xl shadow-amber-400/30">
                  <img
                    src={heroData.profileImage}
                    alt="Deepak — Chart Analyst"
                    className="w-full max-w-md h-auto object-cover"
                    data-testid="hero-profile-photo"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#050e24] via-[#050e24]/70 to-transparent p-5">
                    <p className="text-white font-bold text-lg">Deepak</p>
                    <p className="text-amber-400 text-sm">Founder · Chart Analyst</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Secondary CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center flex-wrap mt-12 max-w-5xl mx-auto">
              <Button
                onClick={handleOpenAccount}
                size="lg"
                data-testid="hero-open-account-btn"
                className="bg-gradient-to-r from-amber-400 to-yellow-500 text-[#050e24] hover:from-amber-500 hover:to-yellow-600 text-base px-6 py-5 font-semibold"
              >
                {heroData.ctaSecondary}
              </Button>
            <Button
              onClick={handleForexFundedAccount}
              size="lg"
              data-testid="hero-forex-funded-btn"
              className="bg-blue-600 hover:bg-blue-700 text-white text-base px-6 py-5"
            >
              Forex Funded Account
            </Button>
            <Button
              onClick={handleIndiabullsDemat}
              size="lg"
              data-testid="hero-indiabulls-demat-btn"
              className="bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white text-base px-6 py-5"
            >
              Free Demat (Indiabulls)
            </Button>
            <Button
              onClick={handleZuperior}
              size="lg"
              data-testid="hero-zuperior-btn"
              className="bg-gradient-to-r from-rose-600 to-pink-600 hover:from-rose-700 hover:to-pink-700 text-white text-base px-6 py-5"
            >
              Forex Zuperior Account
            </Button>
            <Button
              onClick={handleElefin}
              size="lg"
              data-testid="hero-elefin-btn"
              className="bg-gradient-to-r from-teal-600 to-emerald-700 hover:from-teal-700 hover:to-emerald-800 text-white text-base px-6 py-5"
            >
              ELEFIN Forex Account
            </Button>
            <Button
              onClick={handleVantage}
              size="lg"
              data-testid="hero-vantage-btn"
              className="bg-gradient-to-r from-sky-600 to-blue-800 hover:from-sky-700 hover:to-blue-900 text-white text-base px-6 py-5"
            >
              Vantage Markets Account
            </Button>

            <Button
              onClick={handlePremiumSubscription}
              size="lg"
              data-testid="hero-premium-btn"
              className="bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-700 hover:to-orange-700 text-white text-base px-6 py-5"
            >
              Premium Subscription
            </Button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 px-4 bg-[#0a1b3d]">
        <div className="container mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">{aboutData.title}</h2>
            <p className="text-lg text-slate-300 leading-relaxed">{aboutData.description}</p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 px-4">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0a1b3d] mb-4 drop-shadow-sm">Our Services</h2>
            <p className="text-[#0a1b3d]/90 font-medium text-lg">Comprehensive technical analysis solutions for traders</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {servicesData.map((service) => {
              const IconComponent = iconMap[service.icon];
              return (
                <Card key={service.id} className="bg-[#0a1b3d] border-[#1d3263] hover:border-amber-500 transition-all duration-300 hover:transform hover:scale-105">
                  <CardHeader>
                    <div className="w-12 h-12 bg-amber-500/10 rounded-lg flex items-center justify-center mb-4">
                      <IconComponent className="h-6 w-6 text-amber-400" />
                    </div>
                    <CardTitle className="text-white">{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-slate-400">{service.description}</CardDescription>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Technical Research Section */}
      <section id="research" className="py-20 px-4 bg-[#0a1b3d]">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Latest Technical Research</h2>
            <p className="text-slate-400 text-lg">Daily market analysis with precise levels</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {technicalResearchData.map((research) => (
              <Card key={research.id} className="bg-[#0a1b3d] border-[#1d3263] overflow-hidden hover:border-amber-500 transition-all duration-300">
                <div className="h-48 overflow-hidden">
                  <img
                    src={research.imageUrl}
                    alt={research.title}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <CardHeader>
                  <div className="flex justify-between items-start">
                    <CardTitle className="text-white">{research.title}</CardTitle>
                    <span className="text-xs text-amber-400 bg-amber-400/10 px-2 py-1 rounded">{research.date}</span>
                  </div>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="text-slate-300 text-sm">{research.analysis}</p>
                  <div className="space-y-2 bg-[#050e24]/50 p-4 rounded-lg border border-[#1d3263]">
                    <div className="flex justify-between">
                      <span className="text-slate-400 text-sm">Entry:</span>
                      <span className="text-white font-semibold">{research.entry}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-slate-400 text-sm">Target:</span>
                      <span className="text-amber-400 font-semibold">{research.target}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-slate-400 text-sm">Stop Loss:</span>
                      <span className="text-red-500 font-semibold">{research.stopLoss}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 px-4">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0a1b3d] mb-4 drop-shadow-sm">Why Choose Us</h2>
            <p className="text-[#0a1b3d]/90 font-medium text-lg">What makes us different from others</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {whyChooseUsData.map((item) => {
              const IconComponent = iconMap[item.icon];
              return (
                <div key={item.id} className="text-center p-6 bg-[#0a1b3d] rounded-lg border border-[#1d3263] hover:border-amber-500 transition-all duration-300">
                  <div className="w-16 h-16 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <IconComponent className="h-8 w-8 text-amber-400" />
                  </div>
                  <h3 className="text-white font-semibold text-lg mb-2">{item.title}</h3>
                  <p className="text-slate-400 text-sm">{item.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Open Account CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-[#0a1b3d] via-[#0f2454] to-[#0a1b3d] border-y border-amber-400/20">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Start Trading with a <span className="text-amber-400">Trusted Broker</span>
          </h2>
          <p className="text-slate-300 text-lg mb-8 max-w-2xl mx-auto">
            Open your demat account today and start implementing our technical analysis in real trading
          </p>
          <Button
            onClick={handleOpenAccount}
            size="lg"
            className="bg-gradient-to-r from-amber-400 to-yellow-500 text-[#050e24] hover:from-amber-500 hover:to-yellow-600 text-lg px-10 py-6 font-bold shadow-lg shadow-amber-500/30"
          >
            Open Account Now
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </section>

      {/* Forex Funded Account Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-blue-600 to-blue-800">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Trade Forex with Funded Capital
          </h2>
          <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
            Get access to funded trading accounts for Forex trading. Start with firm's capital and keep up to 90% profits!
          </p>
          <Button
            onClick={handleForexFundedAccount}
            size="lg"
            className="bg-white text-blue-600 hover:bg-slate-100 text-lg px-10 py-6 font-semibold"
          >
            Get Forex Funded Account
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </section>

      {/* Free Demat Account — Indiabulls Securities Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-purple-700 via-indigo-700 to-indigo-900">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 py-1.5 mb-4">
              <BadgeCheck className="h-4 w-4 text-amber-300" />
              <span className="text-amber-300 text-sm font-semibold tracking-wide">ZERO ACCOUNT OPENING FEES</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Open A Free Demat Account with Indiabulls Securities
            </h2>
            <p className="text-white/90 text-lg max-w-2xl mx-auto">
              Start your trading journey with India's trusted broker. Get instant access to equity, F&O, mutual funds और IPOs — all with zero opening charges.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-10">
            <Card className="bg-white/10 backdrop-blur-md border-white/20 text-white" data-testid="indiabulls-feature-1">
              <CardHeader>
                <CheckCircle2 className="h-10 w-10 mb-3 text-amber-300" />
                <CardTitle className="text-white">Zero Opening Charges</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-white/90">Open your demat account absolutely free with no hidden fees</p>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-md border-white/20 text-white" data-testid="indiabulls-feature-2">
              <CardHeader>
                <Shield className="h-10 w-10 mb-3 text-amber-300" />
                <CardTitle className="text-white">SEBI Registered</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-white/90">Trade with confidence on a fully regulated & trusted platform</p>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-md border-white/20 text-white" data-testid="indiabulls-feature-3">
              <CardHeader>
                <TrendingUp className="h-10 w-10 mb-3 text-amber-300" />
                <CardTitle className="text-white">Advanced Trading Tools</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-white/90">Professional charts, research reports और fast order execution</p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            <Button
              onClick={handleIndiabullsDemat}
              size="lg"
              data-testid="indiabulls-cta-btn"
              className="bg-gradient-to-r from-amber-400 to-yellow-500 text-[#050e24] hover:from-amber-500 hover:to-yellow-600 text-lg px-10 py-6 font-bold shadow-lg shadow-amber-500/30"
            >
              Open Free Demat Account Now
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

      {/* Forex Zuperior Account Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-rose-600 via-pink-600 to-fuchsia-700">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Open Forex Zuperior Account
            </h2>
            <p className="text-white/90 text-lg max-w-2xl mx-auto">
              Trade global forex markets with Zuperior — fast execution, tight spreads और high leverage. Account open करो और professional forex trading start करो।
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-10">
            <Card className="bg-white/10 backdrop-blur-md border-white/20 text-white" data-testid="zuperior-feature-1">
              <CardHeader>
                <DollarSign className="h-10 w-10 mb-3 text-rose-200" />
                <CardTitle className="text-white">Tight Spreads</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-white/90">Industry-leading low spreads on major forex pairs for better profitability</p>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-md border-white/20 text-white" data-testid="zuperior-feature-2">
              <CardHeader>
                <Activity className="h-10 w-10 mb-3 text-rose-200" />
                <CardTitle className="text-white">Fast Execution</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-white/90">Lightning-fast order execution with no requotes — perfect for scalping</p>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-md border-white/20 text-white" data-testid="zuperior-feature-3">
              <CardHeader>
                <TrendingUp className="h-10 w-10 mb-3 text-rose-200" />
                <CardTitle className="text-white">High Leverage</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-white/90">Maximize trading capital with competitive leverage on forex instruments</p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            <Button
              onClick={handleZuperior}
              size="lg"
              data-testid="zuperior-cta-btn"
              className="bg-white text-rose-600 hover:bg-slate-100 text-lg px-10 py-6 font-semibold"
            >
              Open Zuperior Account Now
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

      {/* ELEFIN Forex Broker Section */}
      <section id="elefin" data-testid="elefin-section" className="scroll-mt-28 py-20 px-4 bg-gradient-to-br from-teal-600 via-emerald-700 to-[#0a1b3d]">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              ELEFIN Forex Broker Account Open
            </h2>
            <p className="text-white/90 text-lg max-w-2xl mx-auto">
              ELEFIN के साथ Forex, Gold और Crypto CFDs trade करो — easy registration, secure funds और smooth trading experience।
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-10">
            {[
              { Icon: Shield, title: 'Secure & Trusted', text: 'Safe fund handling with a reliable global forex broker' },
              { Icon: Activity, title: 'Quick Registration', text: 'Account open करो कुछ ही minutes में — simple online process' },
              { Icon: TrendingUp, title: 'Multiple Markets', text: 'Forex pairs, XAU/USD Gold और अन्य instruments एक ही platform पर' }
            ].map(({ Icon, title, text }, idx) => (
              <Card key={title} className="bg-white/10 backdrop-blur-md border-white/20 text-white" data-testid={`elefin-feature-${idx + 1}`}>
                <CardHeader>
                  <Icon className="h-10 w-10 mb-3 text-emerald-200" />
                  <CardTitle className="text-white">{title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-white/90">{text}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="text-center">
            <Button
              onClick={handleElefin}
              size="lg"
              data-testid="elefin-cta-btn"
              className="bg-white text-emerald-700 hover:bg-slate-100 text-lg px-10 py-6 font-semibold"
            >
              Open ELEFIN Account Now
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

      {/* Vantage Markets Section */}
      <section id="vantage" data-testid="vantage-section" className="scroll-mt-28 py-20 px-4 bg-gradient-to-br from-sky-600 via-blue-800 to-[#050e24]">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Vantage Markets Forex Account Open
            </h2>
            <p className="text-white/90 text-lg max-w-2xl mx-auto">
              Vantage Markets — globally regulated forex broker. Raw spreads, fast execution और MT4/MT5 platforms के साथ trading start करो।
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-10">
            {[
              { Icon: Shield, title: 'Secure & Trusted', text: 'Globally regulated broker with segregated client funds' },
              { Icon: Activity, title: 'Raw Spreads', text: 'Ultra-low spreads और fast execution — scalping के लिए perfect' },
              { Icon: TrendingUp, title: 'Multiple Markets', text: 'Forex, Gold, Indices और Commodities — MT4/MT5 पर' }
            ].map(({ Icon, title, text }, idx) => (
              <Card key={title} className="bg-white/10 backdrop-blur-md border-white/20 text-white" data-testid={`vantage-feature-${idx + 1}`}>
                <CardHeader>
                  <Icon className="h-10 w-10 mb-3 text-sky-200" />
                  <CardTitle className="text-white">{title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-white/90">{text}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="text-center">
            <Button
              onClick={handleVantage}
              size="lg"
              data-testid="vantage-cta-btn"
              className="bg-white text-blue-800 hover:bg-slate-100 text-lg px-10 py-6 font-semibold"
            >
              Open Vantage Account Now
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

      {/* Premium Subscription Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-amber-600 via-orange-600 to-orange-700">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Premium Subscription - Advanced Analysis
            </h2>
            <p className="text-white/90 text-lg max-w-2xl mx-auto">
              Get exclusive access to premium research, daily analysis, and personal support for serious traders
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-10">
            <Card className="bg-white/10 backdrop-blur-md border-white/20 text-white">
              <CardHeader>
                <Target className="h-10 w-10 mb-3 text-amber-200" />
                <CardTitle className="text-white">Daily Premium Analysis</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-white/90">Detailed intraday और swing trade analysis with precise levels</p>
              </CardContent>
            </Card>
            
            <Card className="bg-white/10 backdrop-blur-md border-white/20 text-white">
              <CardHeader>
                <Users className="h-10 w-10 mb-3 text-amber-200" />
                <CardTitle className="text-white">Exclusive Community</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-white/90">Premium members only group with real-time market updates</p>
              </CardContent>
            </Card>
            
            <Card className="bg-white/10 backdrop-blur-md border-white/20 text-white">
              <CardHeader>
                <CheckCircle2 className="h-10 w-10 mb-3 text-amber-200" />
                <CardTitle className="text-white">Personal Support</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-white/90">Direct support for your trading queries and chart analysis</p>
              </CardContent>
            </Card>
          </div>
          
          <div className="text-center">
            <Button
              onClick={handlePremiumSubscription}
              size="lg"
              className="bg-white text-orange-600 hover:bg-slate-100 text-lg px-10 py-6 font-semibold"
            >
              Subscribe to Premium Now
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section id="testimonials" className="py-20 px-4">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0a1b3d] mb-4 drop-shadow-sm">What Traders Say</h2>
            <p className="text-[#0a1b3d]/90 font-medium text-lg">Real feedback from our community</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonialsData.map((testimonial) => (
              <Card key={testimonial.id} className="bg-[#0a1b3d] border-[#1d3263]">
                <CardHeader>
                  <div className="flex items-center space-x-1 mb-2">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-yellow-500 text-yellow-500" />
                    ))}
                  </div>
                  <CardTitle className="text-white text-lg">{testimonial.name}</CardTitle>
                  <CardDescription className="text-amber-400">{testimonial.role}</CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-slate-300 italic">"{testimonial.content}"</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="py-20 px-4 bg-[#0a1b3d]">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 text-center">{disclaimerData.title}</h2>
            <div className="bg-[#0a1b3d] border border-[#1d3263] rounded-lg p-6">
              <ul className="space-y-3">
                {disclaimerData.points.map((point, index) => (
                  <li key={index} className="flex items-start space-x-2">
                    <span className="text-amber-400 mt-1">•</span>
                    <span className="text-slate-300 text-sm">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* YouTube Channel Subscribe Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-red-600 via-red-700 to-red-900">
        <div className="container mx-auto">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-md border border-white/20 rounded-full px-4 py-1.5 mb-4">
                <Youtube className="h-4 w-4 text-white" />
                <span className="text-white text-sm font-semibold tracking-wide">FREE YOUTUBE CHANNEL</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
                Subscribe to <span className="text-amber-300">{youtubeData.channelName}</span>
              </h2>
              <p className="text-white/90 text-lg max-w-2xl mx-auto">
                {youtubeData.description}
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
              {youtubeData.features.map((feature, idx) => (
                <div key={idx} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg px-4 py-3 text-center" data-testid={`yt-feature-${idx}`}>
                  <CheckCircle2 className="h-5 w-5 text-amber-300 mx-auto mb-2" />
                  <p className="text-white font-semibold text-sm">{feature}</p>
                </div>
              ))}
            </div>

            <div className="text-center">
              <Button
                onClick={handleYouTube}
                size="lg"
                data-testid="youtube-subscribe-btn"
                className="bg-white text-red-700 hover:bg-slate-100 text-lg px-10 py-6 font-bold shadow-xl shadow-red-900/50"
              >
                <Youtube className="mr-2 h-6 w-6" />
                Subscribe on YouTube
                <Bell className="ml-2 h-5 w-5" />
              </Button>
              <p className="text-white/70 text-sm mt-3">{youtubeData.channelHandle}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#050e24] border-t border-[#1d3263] py-12 px-4">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <LineChart className="h-6 w-6 text-amber-400" />
                <span className="text-lg font-bold text-white">DD Financial Services By Deepak Chart Analysis</span>
              </div>
              <p className="text-slate-400 text-sm">
                Professional technical analysis and research platform for Indian traders
              </p>
            </div>
            
            <div>
              <h3 className="text-white font-semibold mb-4">Contact Us</h3>
              <div className="space-y-2">
                <a 
                  href={contactData.whatsappLink} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-slate-400 hover:text-amber-400 transition-colors text-sm"
                >
                  <Phone className="h-4 w-4 text-amber-400" />
                  <span>{contactData.whatsapp}</span>
                </a>
                <div className="flex items-center space-x-2 text-slate-400 text-sm">
                  <Send className="h-4 w-4 text-amber-400" />
                  <span>{contactData.telegram}</span>
                </div>
                <div className="flex items-center space-x-2 text-slate-400 text-sm">
                  <Mail className="h-4 w-4 text-amber-400" />
                  <span>{contactData.email}</span>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-white font-semibold mb-4">Follow Us</h3>
              <div className="flex space-x-4">
                <a href={contactData.socialMedia.youtube} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-amber-400 transition-colors">
                  <Youtube className="h-6 w-6" />
                </a>
                <a href={contactData.socialMedia.twitter} className="text-slate-400 hover:text-amber-400 transition-colors">
                  <Twitter className="h-6 w-6" />
                </a>
                <a href={contactData.socialMedia.instagram} className="text-slate-400 hover:text-amber-400 transition-colors">
                  <Instagram className="h-6 w-6" />
                </a>
                <a href={contactData.socialMedia.facebook} className="text-slate-400 hover:text-amber-400 transition-colors">
                  <Facebook className="h-6 w-6" />
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-[#1d3263] pt-8 text-center">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} DD Financial Services By Deepak Chart Analysis. All rights reserved.
            </p>
            <p className="text-slate-500 text-xs mt-2">
              For educational and research purposes only. Not investment advice.
            </p>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <button
        onClick={handleWhatsApp}
        data-testid="floating-whatsapp-btn"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl shadow-green-500/40 transition-transform hover:scale-110 animate-pulse"
      >
        <MessageCircle className="h-7 w-7" />
      </button>
    </div>
  );
};

export default Home;